import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import usePayment from "../hooks/usePayment";
import { toast } from "react-toastify";

const StyledButton = styled.button`
  width: fit-content;
  margin-top: 30px;
  border: 0;
  outline: none;
`;
const StyledDiv = styled.div`
  padding: 300px 0 200px;
  display: grid;
  gap: 5px;
  place-content: center;
  height: 600px;
  text-align: center;
  & p {
    padding-bottom: 0;
    margin-bottom: 0;
  }
`;

const LoadingDiv = styled.div`
  inset: 0;
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  display: grid;
  place-content: center;
  color: white;
  z-index: 1000;
  text-align: center;
`;

const Loading = () => {
  return (
    <LoadingDiv>
      <div class="spinner-border mx-auto mb-1" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <p>Confirming Payment...</p>
    </LoadingDiv>
  );
};

const Success = () => {
  const [ref, setRef] = useState("");
  const [loading, setLoading] = useState(false);
  // const orderId = window.localStorage.getItem("orderId");
  const search = useLocation().search;

  const { handleConfirmPayment } = usePayment();

  const toastOptions = {
    theme: "colored",
    position: "top-center",
    autoClose: false,
    hideProgressBar: true,
  };

  useEffect(() => {
    const confirmPayment = () => {
      const payload = {
        ref,
        // id: orderId,
      };
      setLoading(true);
      handleConfirmPayment(payload)
        .then((res) => {
          toast.success(
            "Congratulations. Your order has been placed succesfully!!!",
            toastOptions
          );
          setTimeout(() => {
            window.location.href =
              "https://2mseamless-tailoring.vercel.app/tailoring";
          }, 5000);
        })
        .catch((err) => console.log(err))
        .finally(() => setLoading(false));
    };
    setTimeout(() => {
      confirmPayment();
    }, 3000);
     // eslint-disable-next-line
  }, [ref]);

  useEffect(() => {
    const paymentReference = new URLSearchParams(search).get(
      "paymentReference"
    );
    setRef(paymentReference);
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <StyledDiv className="">
        <p className="fs-5">Thanks for patronizing 2mseamless!!!</p>
        <p className="text-success">Your payment was successful !!!</p>
        {/* <p className="mt-5">
          But be sure to click the{" "}
          <span className="text-danger">button below</span> to verify your
          payment !!!
        </p>
        <StyledButton
          // onClick={confirmPayment}
          className="px-4 mx-auto py-2 rounded-1"
        >
          {" "}
          Verify Payment{" "}
        </StyledButton> */}
      </StyledDiv>
      {loading && <Loading />}
    </>
  );
};

export default Success;
